export default __webpack_public_path__ + "static/media/lockSharpIcon.26e2017c.svg";